import { useContext, useEffect, useState } from 'react';
import { CharacterCounterContainer, Progress, ProgressBar } from './styles';
import { TtsContext } from '../../../../contexts/TtsContext';
import { Tag } from '../../../Tag';
import { useStore } from '../../../../store';
import { useTranslation } from 'react-i18next';

interface CharacterCounterProps {
  isTrial: boolean;
}

export const CharacterCounter = ({ isTrial }: CharacterCounterProps) => {
  const limit = isTrial ? 2000 : 10000; //RENATO - Ajustar aqui para 10000

  const { blocks } = useStore();

  const { t } = useTranslation('myapps');

  const { setLimitReached, limitReached } = useContext(TtsContext);

  const getCount = () => {
    const text =
      blocks
        .map((block) => block.html)
        .join('')
        .replaceAll('&bnsp;', ' ').length ?? 0;

    if (text > limit) {
      setLimitReached(true);
      return text;
    } else {
      limitReached && setLimitReached(false);
      return text;
    }
  };

  const percentage = Math.round((getCount() / limit) * 100);
  const width = percentage > 100 ? 100 : percentage;

  return (
    <CharacterCounterContainer>
      {limitReached ? (
        <span>
          {t('TTS_CHARACTERS_LIMIT_OVER', { over: getCount() - limit, limit })}
        </span>
      ) : (
        <span>
          {limit - getCount()} {t('TTS_CHARACTERS_REMAINING')}
          {isTrial && <Tag color="default" content="trial" compact />}
        </span>
      )}
      <ProgressBar>
        <Progress style={{ width: `${width}%` }} />
      </ProgressBar>
    </CharacterCounterContainer>
  );
};
